import React from 'react';
import { TableHead as MuiTableHead } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
// import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';
import TableRow from './TableRow';
import classnames from 'classnames';
import { TABLE_ROW_TYPES } from './constants';
import { IColumn } from './interface';

const useStyles = makeStyles()((theme) => ({
  tableHead: {
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    minWidth: 650,
    fontWeight: 700,
    '& .MuiTableRow-head': {
      height: 34,
    },
  },
}));

interface ITableHead {
  headCells?: Array<IColumn>;
  styles: any;
  onClickAllRows?: () => void;
}

const TableHead = ({
  headCells,
  styles,
  onClickAllRows = () => {},
}: ITableHead) => {
  const { classes } = useStyles();
  return (
    // <DndProvider backend={HTML5Backend} context={window}>
    <MuiTableHead className={classnames(styles?.tableHead, classes.tableHead)}>
      <TableRow
        type={TABLE_ROW_TYPES.HEAD}
        columns={headCells}
        styles={styles}
        onSelectAll={onClickAllRows}
      />
    </MuiTableHead>
    // </DndProvider>
  );
};

export default TableHead;
